<template>
<modal name="jobRoleDetail" transition="pop-out" :width="modalWidth" :height="500">
  <div class="modal__header">
      <h4>Viewing Job Role </h4>
  </div>
   <div class="cas_input">
      <div class="row__wrapper">
          <div class="row">
            <div class="col-md-12">
                <div class="" style="width: 100%">
                    <span>Designation Task</span>
                    <div class="">
                        <textarea type="text" rows="5" placeholder="competency name" class="ml-3" v-model="jobRole.task" disabled />
                    </div>
                </div>
            </div>
        </div>
      </div>

      <div class="row__wrapper">
          <div class="row">
            <div class="col-md-12">
                <div class="" style="width: 100%">
                    <span>Designation Name</span>
                    <div class="">
                        <input type="text" disabled placeholder="" class="ml-3" v-model="jobRole.designationName"  />
                    </div>
                </div>
            </div>
        </div>
      </div>
  </div>
</modal>
</template>
<script>
const MODAL_WIDTH = 850;
import configObject from "@/config";

export default {
  name: 'jobRoleDetail',
  props:  ['jobRole'],
  data () {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled:  false,
      showLoader: false,
    }
  },

  created () {
    this.modalWidth = window.innerWidth < MODAL_WIDTH
      ? MODAL_WIDTH / 2
      : MODAL_WIDTH

    console.log(configObject.authConfig);

  },
  methods: {
    changeRoute($routeName) {
        this.$router.push({name: $routeName , query: {
            id: this.branch.id
        }});
    },
    closeCreateBranchModal(){
        this.$modal.hide('editBranchModal');
    },
  }
}
</script>
